import { forwardRef } from 'react';

import MultiSelect, { MultiSelectProps } from './MultiSelect';
import { GroupContainer, GroupName } from './MultiSelectGroup.styled';

export type MultiSelectGroupProps = MultiSelectProps & {
  groupName?: string;
};

const MultiSelectGroup = forwardRef<HTMLDivElement, MultiSelectGroupProps>(
  (props, ref) => {
    const { groupName, ...rest } = props;

    if (!groupName) {
      return <MultiSelect ref={ref} {...rest} />;
    }

    return (
      <GroupContainer key={groupName} ref={ref}>
        <GroupName>{groupName}</GroupName>
        <MultiSelect data-group={groupName} {...rest} />
      </GroupContainer>
    );
  },
);

export default MultiSelectGroup;
